import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import useWindowDimensions from "./formatted/UseWindowsDimensions.js";
import { MaterialCountingPieChart } from "./charts/MaterialCountingPieChart.js";

const ActivityDistributionCharts = ({
  activatedSortingErrorOption,
  dataAnomalyDelivery,
  labelsAnomalyDelivery,
  colorAnomalyDelivery,
  numberOfAnomaly,
  anomalyChartTotals,
  showMaterialDistributionCharts = true,
  dataNumberOfObject,
  labelObjectSeparate,
  numberOfObjects,
  colorObject,
  showAnomalyCharts = true,
  showMaterialCharts = true,
}) => {
  const { t } = useTranslation();
  const { heightWindow } = useWindowDimensions();
  const chartHeight = useMemo(() => heightWindow / 1.5, [heightWindow]);

  return (
    <>
      {showAnomalyCharts &&
        activatedSortingErrorOption &&
        dataAnomalyDelivery &&
        dataAnomalyDelivery.map((dataChart, index) => (
          <article
            key={`anomaly-chart-${index}`}
            className="bg-white rounded-xl w-full truncate"
          >
            <div className="modal-item-container-title">
              <h5 className="data-bold modal-item-container-quality-current">
                {t("Distribution of anomalies")}
              </h5>
            </div>
            <div className="flex justify-center">
              <div style={{ height: chartHeight }}>
                <MaterialCountingPieChart
                  dataChart={dataChart}
                  labelChart={labelsAnomalyDelivery[index]}
                  materialTotal={numberOfAnomaly[index]}
                  chartTotal={anomalyChartTotals?.[index]}
                  colorChart={colorAnomalyDelivery[index]}
                  statistic={true}
                  showMaterialTotal={true}
                  centerLabelVariant="errors"
                />
              </div>
            </div>
          </article>
        ))}
      {showMaterialCharts &&
        showMaterialDistributionCharts &&
        dataNumberOfObject &&
        dataNumberOfObject.map((chartData, index) => (
          <article
            key={`material-chart-${index}`}
            className="bg-white rounded-xl w-full truncate"
          >
            <div className="modal-item-container-title-column">
              <h5 className="data-bold">{t("Material distribution")}</h5>
            </div>
            <div className="flex justify-center">
              <div style={{ height: chartHeight }}>
                <MaterialCountingPieChart
                  dataChart={chartData}
                  labelChart={labelObjectSeparate[index]}
                  materialTotal={numberOfObjects[index]}
                  colorChart={colorObject[index]}
                  statistic={true}
                  showMaterialTotal={true}
                />
              </div>
            </div>
          </article>
        ))}
    </>
  );
};

export default ActivityDistributionCharts;
